export const Constants = {
  IconTypeNone: 'None',
  IconTypeAlert: 'Alert',
  IconTypeInfo: 'Info',
};
